import React, { useState, useImperativeHandle, forwardRef, useCallback } from 'react';
import { Modal } from 'semantic-ui-react';

import { FormattedMessageHelper } from '../../shared/helpers/internationalization';

export interface ExitTutorialModeConfirmationModalProps {
  onCancelExit?: () => void;
  onConfirmExit?: () => void;
}

export interface ExitTutorialModeConfirmationModalHandle {
  open: () => void;
}

export const ConsultantExitTutorialModeConfirmationModal = forwardRef<
  ExitTutorialModeConfirmationModalHandle,
  ExitTutorialModeConfirmationModalProps
>(({ onCancelExit, onConfirmExit }, ref) => {
  const [isOpen, setIsOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    open: () => setIsOpen(true),
  }));

  const handleCancelExit = useCallback(() => {
    setIsOpen(false);
    onCancelExit?.();
  }, [onCancelExit]);

  const handleConfirmExit = useCallback(() => {
    setIsOpen(false);
    onConfirmExit?.();
  }, [onConfirmExit]);

  return (
    <Modal open={isOpen} size="tiny" closeIcon onClose={handleCancelExit} data-testid="exit-tutorial-mode-confirmation-modal">
      <Modal.Header>
        <FormattedMessageHelper id="exitTutorialConfirmation.title" />
      </Modal.Header>
      <Modal.Content>
        <FormattedMessageHelper id="exitTutorialConfirmation.description.1" tagName="p" />
        <FormattedMessageHelper id="exitTutorialConfirmation.description.2" tagName="p" />
      </Modal.Content>
      <Modal.Actions>
        <button className="button button--secondary" onClick={handleCancelExit}>
          <FormattedMessageHelper id="exitTutorialConfirmation.cancel" />
        </button>
        <button className="button button--danger" onClick={handleConfirmExit} data-testid="confirm-exit-tutorial-mode-btn">
          <FormattedMessageHelper id="exitTutorialConfirmation.exit" />
        </button>
      </Modal.Actions>
    </Modal>
  );
});
